import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCameraRetro } from '@fortawesome/pro-solid-svg-icons';
import { faGift, faNewspaper } from '@fortawesome/pro-light-svg-icons';
import { faSmilePlus } from '@fortawesome/pro-regular-svg-icons';
import { faFilm, faStars, faWebcam } from '@fortawesome/pro-solid-svg-icons';
import React, { useContext } from 'react';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { useSelector } from '../../../redux';
import { HeaderContext } from '../HeaderProvider';
import { MobileLink } from './MobileLink';
import { useGenerateCamUrlWithParams } from 'src/client/helpers/urls/useGenerateCamUrlWithParams';

type MobileLink = {
  alsoActiveOn?: string[];
  className?: string;
  icon: IconProp;
  label: string;
  requiresAuth?: boolean;
  to?: string;
  href?: string;
  openNewWindow?: boolean;
};

export const MobileLinksList = () => {
  const config = useSelector((state) => state.app.config);
  const user = useSelector((state) => state.auth.user);
  const [joinUrl] = useJoinUrl({ campaign: 'mobile-menu' });
  const { setMobileMenuOpened } = useContext(HeaderContext);

  const closeMobileMenu = () => setMobileMenuOpened(false);

  const generateCamUrlWithParams = useGenerateCamUrlWithParams({
    trackingPosition: 'mobileMenu',
    provider: config?.camProviders?.[0].provider ?? 'streamate',
  });

  const { movies } = config;

  const noUserOrSubscription = !user || !user.validSubscription;
  const showEroticFilmsLink: boolean = movies.requiresAuth ? movies.active && !!user : movies.active;
  const showBlogLink = config.hasBlog && config.blog.active && !config.featureFlags?.enableSeoCategoriesMenu;
  const showSingleCamProviderLink = config?.camProviders?.length === 1;

  return (
    <>
      <MobileLink
        disabled={!noUserOrSubscription}
        label="Join Now"
        href={joinUrl}
        icon={faSmilePlus}
        className={'join-now'}
        handleClick={closeMobileMenu}
      />
      <MobileLink
        disabled={!config.hasUpdates}
        label="Updates"
        to="/updates"
        icon={faGift}
        handleClick={closeMobileMenu}
      />
      <MobileLink
        disabled={!showEroticFilmsLink}
        label="Films"
        to="/erotic-films"
        icon={faFilm}
        handleClick={closeMobileMenu}
      />
      <MobileLink label="Photos" to="/galleries" icon={faCameraRetro} handleClick={closeMobileMenu} />
      <MobileLink label="Models" to="/models" icon={faStars} handleClick={closeMobileMenu} />
      <MobileLink disabled={!showBlogLink} label="Blog" to="/blog" icon={faNewspaper} handleClick={closeMobileMenu} />
      <MobileLink
        disabled={!showSingleCamProviderLink}
        label="Live Girls"
        href={generateCamUrlWithParams('/cams-list')}
        icon={faWebcam}
        openNewWindow={true}
        handleClick={closeMobileMenu}
      />
    </>
  );
};
